import simran1 from "./simran1.png";
import simran2 from "./simran2.png";
import simran3 from "./simran3.png";
import simran4 from "./simran4.png";
import simran5 from "./simran5.png";
import simran6 from "./simran6.png";
import simran7 from "./simran7.png";
import simran8 from "./simran8.png";
import simran9 from "./simran9.png";


const items = [
  {
    id: 1,
    name: "Sim1",
    category: "women",
    image: simran1,
    new_price: 50.0,
    old_price: 80.5,
  },
  {
    id: 2,
    name: "sim2",
    category: "women",
    image: simran2,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 3,
    name: "sim3",
    category: "women",
    image: simran3,
    new_price: 60.0,
    old_price: 100.5,
  },
  {
    id: 4,
    name: "sim4",
    category: "women",
    image: simran4,
    new_price: 100.0,
    old_price: 150.0,
  },
  {
    id: 5,
    name: "sim5",
    category: "women",
    image: simran5,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 6,
    name: "sim8",
    category: "women",
    image: simran6,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 7,
    name: "sim7",
    category: "women",
    image: simran7,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 8,
    name: "sim8",
    category: "women",
    image: simran8,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 9,
    name: "SIM9",
    category: "women",
    image: simran9,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 10,
    name: "Sim10",
    category: "women",
    image: simran9,
    new_price: 85.0,
    old_price: 120.5,
  }
]

export default items;